import { render, staticRenderFns } from "./shortcutPanel.vue?vue&type=template&id=d7828834&scoped=true"
import script from "./shortcutPanel.vue?vue&type=script&lang=js"
export * from "./shortcutPanel.vue?vue&type=script&lang=js"
import style0 from "./shortcutPanel.vue?vue&type=style&index=0&id=d7828834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7828834",
  null
  
)

export default component.exports